var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('p',{staticClass:"text-title mon-bold"},[_vm._v(_vm._s(_vm.texts.article.titleScreen))])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }